import React from "react"
import {FieldAutomationTriggerFormProps} from "../../../render/automation-trigger-form";

export default function FieldProto_AutomationTriggerForm(props: FieldAutomationTriggerFormProps) {

    return (
        <div className="ui5-txt-default ui5-txt-red">{props.field.type}.automationTriggerForm</div>
    )

}